module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"firstName":"First name","lastName":"Last name","email":"E-mail","save":"Save","dataSaved":"Data saved"}}')
  delete Component.options._Ctor
}
